/**
 * Tooltip copy for AI Impact Assessment action icons (Assessment Center grid + Results modal).
 */

export type AiImpactActionTooltipState = Readonly<{
  hasReport: boolean;
  disabledByBusy: boolean;
  downloadingThis: boolean;
  onViewReport?: boolean;
  onDownloadReport?: boolean;
  onStartManualAssessment?: boolean;
  onRetry?: boolean;
}>;

export function getAiImpactViewReportTooltip(
  state: AiImpactActionTooltipState,
): string {
  if (state.disabledByBusy) return "Please wait…";
  if (!state.hasReport) return "No report available";
  if (!state.onViewReport) return "View PDF unavailable";
  return "View PDF";
}

export function getAiImpactDownloadReportTooltip(
  state: AiImpactActionTooltipState,
): string {
  if (state.disabledByBusy) return "Please wait…";
  if (state.downloadingThis) return "Downloading…";
  if (!state.hasReport) return "No report available";
  if (!state.onDownloadReport) return "Download unavailable";
  return "Download PDF";
}

export function getAiImpactStartManualAssessmentTooltip(
  state: Pick<
    AiImpactActionTooltipState,
    "disabledByBusy" | "onStartManualAssessment"
  >,
): string {
  if (state.disabledByBusy) return "Please wait…";
  if (!state.onStartManualAssessment) {
    return "Start Manual Assessment unavailable";
  }
  return "Start Manual Assessment";
}

export function getAiImpactRerunTooltip(
  state: Pick<AiImpactActionTooltipState, "disabledByBusy" | "onRetry">,
): string {
  if (state.disabledByBusy) return "Please wait…";
  if (!state.onRetry) return "Re-run unavailable";
  return "Re-run";
}
